import React from 'react';
import { Result } from 'antd';
import ResubscriptionButton from './ResubscriptionButton';

export default function UnsubscribeSuccess() {
  return (
    <Result
      status="success"
      subTitle={
        <div>
          You have been un-subscribed from Turing emails!
          <ResubscriptionButton />
        </div>
      }
      title={'You have Unsubscribed'}
    />
  );
}
